import classNames from 'classnames'
import GoogleMapReact from 'google-map-react'
import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import Row from 'components/Row'
import Text from 'components/Text'
import urls from 'constants/urls'
import styles from './GoogleMap.module.scss'
//import markerIconImage, { ReactComponent as MarkerIconSvg } from './images/marker-icon.svg'
import { ReactComponent as MarkerIconSvg } from './images/marker-icon.svg'

export default function GoogleMap({ center, className, marker, zoom }) {
  return (
    <div className={classNames('GoogleMap', styles.this, className)}>
      <div className={styles.inner}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyCyPw2h5CAEBUk5QQl8yU-s10BHEJVzSsA' }}
          defaultCenter={center}
          defaultZoom={zoom}
          options={{
            mapTypeControl: false,
            panControl: false,
            scrollwheel: false,
            styles: [
              {
                stylers: [
                  { 'gamma': 0.8 },
                  { 'lightness': 4 },
                  { 'saturation': -100 },
                  { 'visibility': 'simplified' },
                ],
              },
            ],
          }}>
          {marker && (
            <div
              lat={GoogleMap.defaultProps.center.lat}
              lng={GoogleMap.defaultProps.center.lng}
              className={styles.marker}
              //style={{}}
            >
              <MarkerIconSvg
                className={styles['marker--icon']}
              />
              <div className={styles['info-window']}>
                <Row size="xsmall">
                  <Text copy element="address" wrap={false}>
                    1435 South Ave.
                    <br />
                    Rochester, NY
                  </Text>
                </Row>
                <Button to={urls.GOOGLE_MAPS_DIRECTIONS} full size="xsmall">
                  Get directions
                </Button>
              </div>
            </div>
          )}
        </GoogleMapReact>
      </div>
    </div>
  )
}

GoogleMap.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  className: PropTypes.string,
  marker: PropTypes.bool,
  zoom: PropTypes.number,
}

GoogleMap.defaultProps = {
  center: {
    lat: 43.1274129,
    lng: -77.6128366,
  },
  marker: true,
  //zoom: 18,
  zoom: 14,
}